import { Icon } from "best-common-react";
import styled from "styled-components";

export const ModalBody = styled.div.attrs(() => ({
    className: "m-4",
}))`
    min-height: 420px;
    max-height: 75vh;
    overflow-y: auto;
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
`;

export const ToolbarRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;
`;

export const ErrorText = styled.div`
    font-family: Helvetica;
    font-size: 14px;
    color: var(--red);
`;

export const AccordionItem = styled.div`
    border: 1px solid var(--blue-grey);
    border-radius: 4px;
    margin-bottom: 8px;
    overflow: hidden;
`;

export const AccordionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    background-color: #dee5ed;
    cursor: pointer;
    font-family: Helvetica;
    font-size: 14px;
    color: #041e42;
`;

export const AccordionBody = styled.div`
    padding: 0;
    border-top: 1px solid var(--blue-grey);
    background-color: #fff;
`;

export const CommentSection = styled.div`
    max-height: 290px;
    overflow-y: auto;
    padding: 12px 14px;
    background-color: #fff;
    border-bottom: 1px solid var(--blue-grey);
`;

export const ActionSection = styled.div`
    padding: 12px 14px;
    background-color: var(--cloud);
`;

export const CommentText = styled.div`
    font-family: Helvetica;
    font-size: 13px;
    line-height: 1.5;
    color: var(--slate);
    white-space: pre-wrap;
`;

export const CommentBlockLabel = styled.div`
    font-family: Helvetica;
    font-size: 12px;
    font-weight: 600;
    color: #92a5ba;
    margin-bottom: 4px;
`;

export const CommentBlock = styled.div`
    margin-bottom: 12px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const ActionRow = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
`;

export const MoveToLabel = styled.span`
    font-family: Helvetica;
    font-size: 14px;
    color: var(--slate);
    white-space: nowrap;
`;

export const StyledSelect = styled.select`
    font-family: Helvetica;
    font-size: 13px;
    height: 28px;
    min-width: 180px;
    border: 1px solid var(--blue-grey);
    border-radius: 4px;
    padding: 0 8px;
    color: var(--slate);
`;

export const StyledIcon = styled(Icon)<{ color: string }>`
    color: ${props => props.color};
`;
